const ReactivateUserApiUrls = {
  REACTIVATE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/reactivate-user/unlock`
};

export default ReactivateUserApiUrls
